import { useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { usePlace } from "../../providers/PlaceProvider";

export default function Offer() {
  const navigator = useNavigate();
  const { t } = useTranslation("", { keyPrefix: "sidenav.offer" });
  const { selectedPlace } = usePlace();

  const trialEndDate = selectedPlace?.end_trial ?? null;
  const now = Date.now();
  const trialEnded = trialEndDate ? new Date(trialEndDate).getTime() < now : false;
  const nearTrialEnd = trialEndDate
    ? !trialEnded && new Date(trialEndDate).getTime() - now < 7 * 24 * 60 * 60 * 1000
    : false;

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      if (!trialEndDate) return;
      const end = new Date(trialEndDate).getTime();
      const now = Date.now();
      const difference = Math.max(0, end - now);

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((difference / 1000 / 60) % 60);
      const seconds = Math.floor((difference / 1000) % 60);

      setTimeLeft({ days, hours, minutes, seconds });
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, [trialEndDate]);

  // Show banner only when near end or ended. If ended, still show.
  if ((!nearTrialEnd || !trialEndDate) && !trialEnded) {
    return null;
  }

  return (
    <Box
      sx={{
        p: 3,
        border: "1px solid #FF2559",
        borderRadius: 2,
        background: "#FFD0D0",
        textAlign: "center",
        my: 3,
      }}
    >

        <Typography fontWeight={600} mb={2}>
          {trialEnded ? t("ended.title") : t("soon.title")}
        </Typography>

        {!trialEnded && (
          <Typography fontWeight={800} color="#FF2559" mb={2}>
            {t("soon.leftOnly")}
          </Typography>
        )}

        {!trialEnded && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 1,
              mb: 2,
            }}
          >
            <Box sx={{ textAlign: "center" }}>
              <Typography fontWeight={700} fontSize="24px" >
                {timeLeft.days}
              </Typography>
              <Typography fontSize="12px" color="#555">
                {t("units.days")}
              </Typography>
            </Box>
            <Typography fontWeight={700} fontSize="24px" sx={{ pb: "18px" }}>
              :
            </Typography>
            <Box sx={{ textAlign: "center" }}>
              <Typography fontWeight={700} fontSize="24px">
                {String(timeLeft.hours).padStart(2, "0")}
              </Typography>
              <Typography fontSize="12px" color="#555">
                {t("units.hours")}
              </Typography>
            </Box>
            <Typography fontWeight={700} fontSize="24px" sx={{ pb: "18px" }}>
              :
            </Typography>
            <Box sx={{ textAlign: "center" }}>
              <Typography fontWeight={700} fontSize="24px">
                {String(timeLeft.minutes).padStart(2, "0")}
              </Typography>
              <Typography fontSize="12px" color="#555">
                {t("units.minutes")}
              </Typography>
            </Box>
            <Typography fontWeight={700} fontSize="24px" sx={{ pb: "18px" }}>
              :
            </Typography>
            <Box sx={{ textAlign: "center" }}>
              <Typography fontWeight={700} fontSize="24px">
                {String(timeLeft.seconds).padStart(2, "0")}
              </Typography>
              <Typography fontSize="12px" color="#555">
                {t("units.seconds")}
              </Typography>
            </Box>
          </Box>
        )}

      <Typography fontWeight={400} mb={2}>
        {trialEnded ? t("ended.sub") : t("soon.sub")}
      </Typography>
      <Button sx={{ width: "100%", backgroundColor: "#FF2559" }} variant="contained" onClick={() => navigator("/campaign/change-plan")}>
        {trialEnded ? t("ended.cta") : t("soon.cta")}
      </Button>
    </Box>
  );
}
